export enum TypesOfPlansEnum {
	SMART = '6',
	NOTREDAME_SAUDE = '5',
	ADVANCE = '7',
	INFINITY = '8',
	NOSSO_PLANO = '4',
	NOSSO_MEDICO = '3',
	OURO = '10',
	PRATA = '12',
	DIAMANTE = '11',
}
